module.exports = __webpack_public_path__ + "img/tapak-semaian-kelapa-tacunan-4.a5ecaf2a.jpeg";